// frontend/modules/service-metrics/index.ts
import { ModuleConfig } from '@/core/module';
import { serviceMetricsRoutes } from './routes';
import { useServiceMetricsStore } from './stores/service-metrics-store';

// Export hooks
export { useServiceMetrics } from './hooks/useServiceMetrics';

// Export components
export { default as ServiceHealthCard } from './components/ServiceHealthCard';
export { default as ServiceMetricsTrendChart } from './components/ServiceMetricsTrendChart';
export { default as TopServicesTable } from './components/TopServicesTable';
export { default as ServiceLogsTable } from './components/ServiceLogsTable';
export { default as RecentErrorsCard } from './components/RecentErrorsCard';
export { default as ServiceSummaryStats } from './components/ServiceSummaryStats';

// Export views
export { default as ServiceMetricsDashboardView } from './views/ServiceMetricsDashboardView';

// Re-export types from Orval-generated model
export type {
    ServiceMetricDTO,
    ServiceMetricLogDTO,
    ServiceMetricSummaryDTO,
    ServiceHealthDTO,
} from '@/shared/api/model';

// Export local types
export type { 
    MetricStatus, 
    HealthStatus, 
    TrendDataPoint, 
    ErrorSummary, 
    ServiceMetricsFilters 
} from './types/service-metrics.types';

export const ServiceMetricsModule: ModuleConfig = {
    name: 'service-metrics',
    routes: serviceMetricsRoutes,
    stores: {
        serviceMetrics: useServiceMetricsStore
    },
    initialize: () => {
        console.log('Service Metrics module initialized');
    }
};
